import { ExportOutlined } from '@ant-design/icons';
import {
  foreignRoute,
  useHref,
} from '@framework/ui/core/router/TypedRoute.tsx';
import { Button, Tooltip } from 'antd';

export interface ILayerCatalogEditLinkButtonProps {
  catalogId: string;
}

/**
 * Apre la pagina di modifica del catalogo livelli in una nuova scheda.
 */
export function LayerCatalogEditLinkButton(
  props: ILayerCatalogEditLinkButtonProps,
) {
  const { catalogId } = props;

  // Route di admin-web (dove il componente viene montato): il package è
  // compilato anche da contesti che non la registrano.
  const href = useHref(foreignRoute('/frontoffice/layer-catalog/:id'), {
    id: catalogId,
  });

  return (
    <Tooltip title="Modifica catalogo in una nuova scheda">
      <Button
        type="default"
        size="large"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        icon={<ExportOutlined aria-hidden="true" />}
        aria-label="Modifica catalogo in una nuova scheda"
      />
    </Tooltip>
  );
}
